// extracted by mini-css-extract-plugin
module.exports = {"input":"InputFile--input","filename":"InputFile--filename"};